<template>
  <KlarnaBanner
    v-if="paymentMethod"
    :base-price
    class="mb-12"
    :payment-method
  />

  <DefaultRedirectionText v-if="paymentGroup" :group="paymentGroup" />

  <slot />
</template>

<script setup lang="ts">
import KlarnaBanner from '../../../../advertising/components/KlarnaBanner/KlarnaBanner.vue'
import type { PaymentFormAdornmentProps } from '../PaymentFormAdornment.type'

import DefaultRedirectionText from './DefaultRedirectionText.vue'

defineProps<PaymentFormAdornmentProps>()
</script>
